import { combineReducers } from 'redux';
import UserReducer from './user/UserReducer';
import AssetReducer from './assets/AssetReducer';
import PathnameReducer from './PathnameReducer';
import UsersReducer from './users/UsersReducer';
import QueryReducer from './query/QueryReducer';

export default combineReducers({
   currentUser: UserReducer,
   currentAssets: AssetReducer,
   requestedPathname: PathnameReducer,
   users: UsersReducer,
   query: QueryReducer
});
